import s from "react";
import { s as t } from "../sr-only.module-DyRe7tkx.mjs";
const c = ({
  children: e,
  className: r,
  ...a
}) => /* @__PURE__ */ s.createElement("span", { className: `${t.srOnly} ${r || ""}`, ...a }, e);
export {
  c as ScreenReaderOnly,
  c as SrOnly
};
